"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { Post } from "@/payload-types";
import { PostImage, getPostImageUrl } from "@/components/ui/PostImage";
import { VideoPlayIndicator } from "@/components/ui/VideoPlayIndicator";
export type VideoCardSize = "sm" | "md" | "lg";
export interface VideoCardProps {
  post: Post;
  displayMode: "vertical" | "landscape";
  cardSize?: VideoCardSize;
  /** Overlay the title on the thumbnail instead of showing it below. */
  overlayTitle?: boolean;
  onClick: () => void;
}
const verticalWidths: Record<VideoCardSize, string> = {
  sm: "w-32 md:w-38",
  md: "w-40 md:w-48",
  lg: "w-50 md:w-60"
};
const landscapeWidths: Record<VideoCardSize, string> = {
  sm: "w-56 md:w-64",
  md: "w-72 md:w-80",
  lg: "w-88 md:w-100"
};
const titleSizes: Record<VideoCardSize, {
  text: string;
  height: string;
}> = {
  sm: {
    text: "text-xs leading-4",
    height: "h-8"
  },
  md: {
    text: "text-sm leading-5",
    height: "h-10"
  },
  lg: {
    text: "text-base leading-6",
    height: "h-12"
  }
};
export const VideoCard: React.FC<VideoCardProps> = t0 => {
  const $ = _c(27);
  const {
    post,
    displayMode,
    cardSize: t1,
    overlayTitle: t2,
    onClick
  } = t0;
  const cardSize = t1 === undefined ? "md" : t1;
  const overlayTitle = t2 === undefined ? false : t2;
  const isVertical = displayMode === "vertical";
  const widthClass = isVertical ? verticalWidths[cardSize] : landscapeWidths[cardSize];
  const title = titleSizes[cardSize];
  const t3 = `shrink-0 group/card relative cursor-pointer overflow-hidden rounded-lg ${overlayTitle ? "" : "bg-card"} ${widthClass}`;
  const t4 = isVertical ? "small" : "medium";
  let t5;
  if ($[0] !== post || $[1] !== t4) {
    t5 = getPostImageUrl(post, t4);
    $[0] = post;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = post.title ?? "";
  const t7 = isVertical ? "9/16" : "video";
  let t8;
  if ($[3] !== t5 || $[4] !== t6 || $[5] !== t7) {
    t8 = <PostImage src={t5} alt={t6} aspectRatio={t7} />;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute inset-0 bg-black/10 group-hover/card:bg-black/25 transition-colors" />;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== cardSize) {
    t10 = <VideoPlayIndicator size={cardSize} />;
    $[8] = cardSize;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== overlayTitle || $[11] !== post.title || $[12] !== title) {
    t11 = overlayTitle && <div className="absolute bottom-0 left-0 right-0 p-2 bg-linear-to-t from-black/80 to-transparent"><p className={`${title.text} font-medium text-white line-clamp-2 text-left`}>{post.title}</p></div>;
    $[10] = overlayTitle;
    $[11] = post.title;
    $[12] = title;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10 || $[15] !== t11 || $[16] !== t8) {
    t12 = <div className="relative">{t8}{t9}{t10}{t11}</div>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t8;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== overlayTitle || $[19] !== post.title || $[20] !== title) {
    t13 = !overlayTitle && <div className="p-2"><p className={`${title.text} font-medium text-card-foreground line-clamp-2 text-left ${title.height}`}>{post.title}</p></div>;
    $[18] = overlayTitle;
    $[19] = post.title;
    $[20] = title;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== onClick || $[23] !== t12 || $[24] !== t13 || $[25] !== t3) {
    t14 = <button onClick={onClick} className={t3}>{t12}{t13}</button>;
    $[22] = onClick;
    $[23] = t12;
    $[24] = t13;
    $[25] = t3;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
};